import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Disclaimer | Aansprakelijkheid & Websitegebruik | Compleet Verzekerd</title>
        <meta name="description" content="Disclaimer Compleet Verzekerd. Informatie over aansprakelijkheid, websitegebruik, intellectueel eigendom en toepasselijk Nederlands recht." />
        <meta name="keywords" content="disclaimer, aansprakelijkheid, website disclaimer, intellectueel eigendom, toepasselijk recht, compleet verzekerd" />
        <link rel="canonical" href="https://compleetverzekerd.nl/disclaimer/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Disclaimer",
            "description": "Disclaimer en aansprakelijkheidsinformatie van Compleet Verzekerd",
            "publisher": {
              "@type": "Organization",
              "name": "Compleet Verzekerd"
            }
          })}
        </script>
      </Helmet>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded">
        Spring naar hoofdinhoud
      </a>
      <Header />
      
      <main id="main-content" className="pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-primary mb-4">Disclaimer</h1>
            <p className="text-xl text-muted-foreground">
              Belangrijke informatie over het gebruik van onze website
            </p>
          </div>

          <div className="space-y-8">
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Algemene informatie</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  De informatie op deze website is met de grootst mogelijke zorgvuldigheid samengesteld. 
                  Compleet Verzekerd kan echter niet garanderen dat alle informatie te allen tijde juist, 
                  volledig of actueel is. Mocht de informatie ondanks onze zorg en aandacht onvolledig 
                  of onjuist zijn, dan kunnen wij daarvoor niet aansprakelijk worden gesteld.
                </p>
                <p className="text-muted-foreground">
                  Wij behouden ons het recht voor om de inhoud van deze website op elk moment zonder 
                  voorafgaande kennisgeving te wijzigen of aan te vullen.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Aansprakelijkheid</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  Compleet Verzekerd aanvaardt geen aansprakelijkheid voor eventuele schade die 
                  voortvloeit uit het gebruik van deze website of uit de onmogelijkheid deze 
                  website te kunnen raadplegen. Deze uitsluiting geldt niet indien de schade 
                  het gevolg is van opzet of grove schuld van Compleet Verzekerd.
                </p>
                <p className="text-muted-foreground">
                  Wij zijn evenmin aansprakelijk voor schade die het gevolg is van het niet 
                  of niet goed functioneren van de telecommunicatieverbinding.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Links naar andere websites</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  Deze website kan links bevatten naar andere websites. Wij hebben geen controle 
                  over de inhoud, het privacybeleid of de handelspraktijken van deze websites. 
                  Het opnemen van links naar andere websites houdt geen goedkeuring in van de 
                  inhoud van die websites.
                </p>
                <p className="text-muted-foreground">
                  Wij raden u aan om het privacybeleid te lezen van elke website die u bezoekt.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Intellectueel eigendom</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  Alle intellectuele eigendomsrechten betreffende deze website en haar inhoud 
                  berusten bij Compleet Verzekerd of bij derden die toestemming hebben gegeven 
                  voor het gebruik van hun materiaal.
                </p>
                <p className="text-muted-foreground">
                  Het is niet toegestaan om inhoud van deze website te kopiëren, te verspreiden 
                  of openbaar te maken zonder voorafgaande schriftelijke toestemming van Compleet Verzekerd.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Toepasselijk recht</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">
                  Op deze disclaimer en het gebruik van onze website is uitsluitend Nederlands recht 
                  van toepassing. Eventuele geschillen zullen worden voorgelegd aan de bevoegde 
                  Nederlandse rechter.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Disclaimer;